//tab types
const types = {
  issue: 'issue',
  quick_action: 'quick_action',
  live_order_task: 'live_order_task',
};

const POLL_INTERVAL = 5000;

const links = [
  {
    key: 'live_order_tasks',
    title: 'Live Order Tasks',
    type: types.live_order_task,
    url: 'get_live_order_tasks',
  },
  {
    key: 'issues',
    title: 'Report An Issue',
    type: types.issue,
    url: 'issues/get_applicable_reasons',
  },
  {
    key: 'quick_actions',
    title: 'Quick Actions',
    type: types.quick_action,
    url: 'issues/get_quick_actions',
  },
];

const TASK_STATUSES = {
  OPEN: 'OPEN',
  inProgress: 'IN_PROGRESS',
  completed: 'COMPLETED',
  rejected: 'REJECT',
  approve: 'APPROVE',
};

//styles for task tag
const getTagStyles = (status) => {
  switch (status) {
    case TASK_STATUSES.OPEN:
      return 'tw-bg-grey-200/70 tw-border tw-border-solid tw-border-grey-200/90 tw-border-[1px]';
    case TASK_STATUSES.inProgress:
      return 'tw-bg-blue-200/70 tw-border tw-border-solid tw-border-blue-200/90 tw-border-[1px]';
    case 'COMPLETE':
      return 'tw-bg-green-200/70 tw-border tw-border-solid tw-border-green-300/30 tw-border-[1px]';
    case TASK_STATUSES.approve:
      return 'tw-bg-green-200/70 tw-border tw-border-solid tw-border-green-300/30 tw-border-[1px]';
    case TASK_STATUSES.rejected:
      return 'tw-bg-red-200/70 tw-border tw-border-solid tw-border-red-200/90 tw-border-[1px]';
  }
};

const ACTION_TYPES = {
  Approve: 'APPROVE',
  Reject: 'REJECT',
};

const TaskSource = Object.freeze({
  SYSTEM: 'system',
  CONSUMER_APP: 'consumer_app',
  RIDER_APP: 'rider_app',
  BOTS: 'bots',
});

const TaskSourceLabels = {
  [TaskSource.SYSTEM]: 'System',
  [TaskSource.CONSUMER_APP]: 'Customer',
  [TaskSource.RIDER_APP]: 'Rider',
  [TaskSource.BOTS]: 'Bots',
};

const SERIALIZE_INPUT_TYPE = {
  MULTIPLE_SELECT: 'multiple_select',
  STEPPER: 'stepper',
};
const dropdownInputCSS = `
                          .rdw-list-dropdown,
                          .rdw-text-align-dropdown {
                            z-index: 0 !important;
                          }
                          > div {
                            width: 100% !important;
                          }
                          .chip {
                            border-radius: 0.6rem !important;
                          }
                        `;

const TAB_INDEXES = {
  LIVE_ORDER: 0,
  REPORT_ISSUE: 1,
  QUICK_ACTION: 2,
};

const parentIconStyle =
  'tw-group tw-h-[45px] tw-w-[45px] tw-aspect-square tw-flex tw-items-center tw-justify-center tw-rounded-xl tw-bg-white hover:tw-bg-green-100/50 tw-transition-all tw-duration-200 tw-ease-in-out tw-cursor-pointer hover:tw-ring-solid hover:tw-ring-[0.5px] hover:tw-ring-green-300/70';

const iconStyle =
  'tw-text-zinc-500 tw-transition-transform tw-duration-200 group-hover:tw-scale-105 group-hover:tw-text-base-green';

export {
  POLL_INTERVAL,
  types,
  getTagStyles,
  TASK_STATUSES,
  ACTION_TYPES,
  TaskSource,
  TaskSourceLabels,
  SERIALIZE_INPUT_TYPE,
  dropdownInputCSS,
  TAB_INDEXES,
  links,
  parentIconStyle,
  iconStyle,
};
